module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAZlBMVEUAAAB5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGtJy/WYAAAAIXRSTlMAHpCLcir27b+pl4BOSDMMBOXgzsmeeWZVQiQU1rihWiUy2x0HAAAAm0lEQVQ4y+3OSQ7CMBBE0UpiZ54hM1Pd/5IEsCwc2TkA5K1q8dVqHP5SOemZcBXMfg+blLNaHT+i0YPFjWH+HguV1reGGcm4eP1A5VrBpg65uvijoFLCyhMRTQWsgnYberB6cKOBg6Cpg0vQGKGES2J0CZxkyC8V3Jb+rLsJe7yYSg6X6p75+t5JwqnOY50N2CeHLE0DUdQ4/J4nrzUa02BPAqcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/Twitter.png
// module id = QJyC
// module chunks = 2